module.exports = __webpack_public_path__ + "media/customizations/myrtlecreek/logo-00ca94cfc6ee2a9b3ac87afedb950b13.png";